export function updateStore(state, payload) {
  return {
    ...state,
    ...payload,
  };
}

export function getDefaultValueFromState(name, defaultValue, state) {
  if (state.data[name]) {
    return state.data[name];
  }

  if (typeof defaultValue === 'undefined') {
    return '';
  }

  return defaultValue;
}
